export default __webpack_public_path__ + "static/media/icon_Frozen.c158de1f.svg";